import { render, staticRenderFns } from "./RenewInfo.vue?vue&type=template&id=284a2daa&scoped=true&"
import script from "./RenewInfo.vue?vue&type=script&lang=js&"
export * from "./RenewInfo.vue?vue&type=script&lang=js&"
import style0 from "./RenewInfo.vue?vue&type=style&index=0&id=284a2daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a2daa",
  null
  
)

export default component.exports